import Vue from "vue";
import App from "./App.vue";
import VueRouter from 'vue-router';
import { 
  DropdownPlugin,
  FormInputPlugin,
  TablePlugin,
  ButtonPlugin,
  ModalPlugin,
  FormGroupPlugin,
  PaginationPlugin ,
  FormSelectPlugin,
  FormPlugin,
  FormCheckboxPlugin,
  FormTextareaPlugin,
  FormFilePlugin,
  InputGroupPlugin,
  OverlayPlugin,
  SpinnerPlugin
} from 'bootstrap-vue';

import CKEditor from 'ckeditor4-vue';

import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(DropdownPlugin);
Vue.use(TablePlugin);
Vue.use(FormInputPlugin);
Vue.use(ButtonPlugin);
Vue.use(ModalPlugin);
Vue.use(FormGroupPlugin);
Vue.use(PaginationPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormFilePlugin);
Vue.use(InputGroupPlugin);
Vue.use(OverlayPlugin);
Vue.use(SpinnerPlugin);
Vue.use(CKEditor);

import store from "./store";

new Vue({
    render: h => h(App),
    store: store
}).$mount("#app");

store.dispatch('getAboutUs');

store.dispatch('getData');